module.exports = "<p>\n  order-details-modal works!\n</p>\n"